import { useMsal } from '@azure/msal-react'
import { useQuery } from '@tanstack/react-query'

import { facadeApi } from 'api'

export interface UserProfile {
  email: string
  firstName: string
  lastName: string
  jobFamilyName?: string
  department?: string
  id?: string
  azureAdObjectId?: string
}

export function useUserQuery() {
  const { accounts } = useMsal()

  return useQuery<UserProfile>({
    queryKey: ['userProfile'],
    queryFn: async () => {
      const response = await facadeApi.client.get<UserProfile>('/v3/users/me?workdaySync=true')
      return response.data
    },
    enabled: accounts.length > 0,
    staleTime: 5 * 60 * 1000,
  })
}
